import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Button from 'carbon-react/lib/components/button';

import { AddNewOrganisationContainer } from '@futrli/organisations/overview/containers/add-new-organisation-container/add-new-organisation-container';
import { getCreateConsolidationUrl, useModal } from '@futrli/shared-services';
import { Integration } from '@futrli-sdk/app-store';
import { PopoverMenu, PopoverMenuItem } from '@futrli/ui-components/components/popover-menu/popover-menu';

interface CreateOrgConPopoverProps {
  integrations: Integration[];
  workspaceId: string;
}

export const CreateOrgConPopover = ({ integrations, workspaceId }: CreateOrgConPopoverProps) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const shouldOpenOnInit = searchParams.get('add_new_org') === 'true';
  const addOrganisation = useModal(shouldOpenOnInit);

  const items: PopoverMenuItem[] = [
    {
      label: <FormattedMessage id="organisations.add_new_organisation_v2" defaultMessage="Create new organisation" />,
      onClick: addOrganisation.open
    },
    {
      label: <FormattedMessage id="consolidation.add_new_consolidation_v2" defaultMessage="Create new consolidation" />,
      onClick: () => navigate(getCreateConsolidationUrl(workspaceId))
    }
  ];

  return (
    <>
      <PopoverMenu
        items={items}
        renderOpenComponent={({ onClick, ref, 'aria-expanded': ariaExpanded }) => (
          <Button
            buttonType="primary"
            iconType="dropdown"
            iconPosition="after"
            onClick={onClick}
            ref={ref}
            aria-expanded={ariaExpanded}
          >
            <FormattedMessage id="common.create" defaultMessage="Create" />
          </Button>
        )}
      />

      <AddNewOrganisationContainer
        integrations={integrations}
        isOpen={addOrganisation.isOpen}
        onClose={addOrganisation.close}
      />
    </>
  );
};
